import { cn } from '@/lib/utils';

export type Visibility = 'private' | 'unlisted' | 'public';

interface VisibilityBadgeProps {
  visibility: Visibility;
  className?: string;
  /** Use 'solid' variant for dark backgrounds */
  variant?: 'default' | 'solid';
}

const visibilityConfig: Record<Visibility, { label: string; default: string; solid: string }> = {
  private: {
    label: 'Private',
    default: 'bg-muted-foreground/15 text-muted-foreground',
    solid: 'bg-muted-foreground text-white',
  },
  unlisted: {
    label: 'Unlisted',
    default: 'bg-amber-400/15 text-amber-600',
    solid: 'bg-amber-500 text-white',
  },
  public: {
    label: 'Public',
    default: 'bg-emerald-400/15 text-emerald-600',
    solid: 'bg-emerald-500 text-white',
  },
};

export function VisibilityBadge({ visibility, className, variant = 'default' }: VisibilityBadgeProps) {
  const config = visibilityConfig[visibility];
  if (!config) return null;

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        config[variant],
        className,
      )}
    >
      {config.label}
    </span>
  );
}
